import styled from "styled-components";

/**
 * The single control the whole site is built around.
 * Physical-feeling toggle: the knob travels, the track warms up,
 * and a soft glow blooms behind it when lit.
 */
export default function LightSwitch({ lit, onToggle, label = true }) {
  return (
    <Wrap>
      <Track
        type="button"
        role="switch"
        aria-checked={lit}
        aria-label={lit ? "Fik dritat" : "Ndez dritat"}
        $lit={lit}
        onClick={onToggle}
      >
        <Glow $lit={lit} />
        <Knob $lit={lit} />
      </Track>
      {label && <Caption $lit={lit}>{lit ? "NDEZUR" : "FIKUR"}</Caption>}
    </Wrap>
  );
}

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
`;

const Track = styled.button`
  position: relative;
  width: 88px;
  height: 44px;
  border-radius: 999px;
  padding: 4px;
  display: flex;
  align-items: center;
  background: ${({ $lit }) => ($lit ? "#3a2a1c" : "rgba(26,24,21,0.10)")};
  border: 1px solid var(--line);
  transition: background 600ms var(--ease), border-color 600ms var(--ease),
    box-shadow 600ms var(--ease);
  box-shadow: ${({ $lit }) =>
    $lit ? "0 0 34px rgba(232,168,106,0.4)" : "none"};

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 4px;
  }
`;

const Knob = styled.span`
  position: relative;
  z-index: 1;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: ${({ $lit }) => ($lit ? "#f6d9ac" : "#faf8f3")};
  box-shadow: ${({ $lit }) =>
    $lit
      ? "0 0 26px 6px rgba(246,217,172,0.75), 0 1px 3px rgba(0,0,0,0.4)"
      : "0 1px 3px rgba(26,24,21,0.22)"};
  transform: translateX(${({ $lit }) => ($lit ? "44px" : "0")});
  transition: transform 620ms var(--ease), background 620ms var(--ease),
    box-shadow 620ms var(--ease);
`;

const Glow = styled.span`
  position: absolute;
  inset: -40px;
  border-radius: 999px;
  pointer-events: none;
  background: radial-gradient(
    closest-side,
    rgba(232, 168, 106, 0.34),
    rgba(232, 168, 106, 0)
  );
  opacity: ${({ $lit }) => ($lit ? 1 : 0)};
  transition: opacity 700ms var(--ease);
`;

const Caption = styled.span`
  font-size: 10px;
  letter-spacing: 0.36em;
  color: var(--ink-soft);
  min-width: 62px;
  transition: color var(--t-theme) var(--ease);
`;
